module.exports = __webpack_public_path__ + "static/media/jg.087164c0.jpg";